import axios from "axios";
import { config } from "../../config";

import { IResponse } from "redmond";
import { locationAutocompleteApiPrefix } from "../paths";

export const fetchLocations = (): Promise<IResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(
        locationAutocompleteApiPrefix,
        { query: { LocationQuery: "Label", l: "" } },
        {
          baseURL: config.baseURL,
        }
      );

      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });
